module.exports = __webpack_public_path__ + "static/assets/367b35dafc4cfb3236e0192217360b9f.png";